import SubTitle from '../common/SubTitle'
import DashboardMapFilter from '../dashboard/DashboardMapFilter';
import { Box } from '@mui/material';

export default function TrackAllStops() {
    const orgName = JSON.parse(localStorage.getItem('userState'))?.organization?.name;
    return (
        <>
            <SubTitle
                title={"Monitor Stops"}
                path={`${orgName || "organization"} > Stops > Monitor Stops `} />
            <Box
                // className="page_container"

                sx={{
                    border: "none",
                    position: "relative",
                    margin: { xs: "0px 20px", md: "0px 40px" },
                    boxShadow: "-2px 1px 5px 1px #00000040",
                    borderRadius: "10px",
                    // padding: "20px",
                    border: "1px solid #A5DCF3"
                }}
            >
                <DashboardMapFilter filterBy='stops' />
            </Box>

        </>
    )
}
